<script setup lang="ts">
import { useKpisPerimeter } from '#composables/kpisPerimeter';
import { useLanguage } from '#composables/useLanguage';
import { useLikeForLike } from '#domain/performance/likeForLike/composables/useLikeForLike';
import { useUserStore } from '#stores/user.store';
import { C4FunctionalNotice, FunctionalNoticeType } from '@c4-links/vue3-links-components';
import { isEcommerceAvailable } from '@carrefour-gcs/shared';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const { t } = useLanguage();
const {
  shouldDisplayLikeForLikeInfoBanner,
  shouldDisplayLikeForLikeErrorBanner,
  dismissLikeForLikeInfoBanner,
  dismissLikeForLikeErrorBanner
} = useLikeForLike();

const userStore = useUserStore();
const { userCountry } = storeToRefs(userStore);
const { storePerimeter } = useKpisPerimeter();

const shouldDisplayInfoAboutEcommerce = computed(
  () => !isEcommerceAvailable(storePerimeter.storePerimeter.value, userCountry.value)
);
</script>

<template>
  <div v-if="shouldDisplayLikeForLikeInfoBanner" class="flex flex-col gap-4 pt-8 pb-4">
    <C4FunctionalNotice :title="t('likeForLike.infoBanner.title')" @close="dismissLikeForLikeInfoBanner">
      <template #body>
        <ul class="text-md list-disc pl-8">
          <li>{{ t('likeForLike.infoBanner.lineOne') }}</li>
          <li>{{ t('likeForLike.infoBanner.lineTwo') }}</li>
          <li v-if="shouldDisplayInfoAboutEcommerce">
            {{ t('likeForLike.infoBanner.lineEcommerce') }}
          </li>
        </ul>
      </template>
    </C4FunctionalNotice>

    <C4FunctionalNotice
      v-if="shouldDisplayLikeForLikeErrorBanner"
      :type="FunctionalNoticeType.WARNING"
      :content="t('likeForLike.warningBanner.content')"
      @close="dismissLikeForLikeErrorBanner"
    />
  </div>
</template>
